import React, { useState, useEffect, useContext } from 'react'

import Input from '../../../components/input/input'


import './firmware-custom.css'
import { MainHeaderContext } from '../../../components/main-header/main-header-state'
import DefaultStatusModals from '../../../components/modal/default-status-modals'

import RemotizeDevices from '../../remotize-devices'
import UpdatefwCustomVersions from './fw-custom-versions'

import Form from '../../../components/form/form'
import Button from '../../../components/button/button'
import Overlay from '../../../components/overlay/overlay'
import CloseIcon from '../../../components/icons/close'
import { BackendContext, backendStatus } from '../../../backend/backend'

import { UserContext } from '../../user-context'
import { UIEventsContext } from '../../uievents-context';

import { useHistory } from 'react-router-dom'
export const updateStatusEnum = { ACTIVE: 0, VALIDATING: 1, PENDING: 2, STOPPED: 3 }



const MAX_FILE_SIZE = 40 * 1024 * 1024 // 40 MB

const excludeModel  = ['Twibi', 'Huawei EG8145V5', 'Huawei EG8141A5', 'Huawei HG8546M', 'Bifrost mock']

const fetchFirmwaresCustom = async (setFirmwaresCustom, setLoading, backend) => {

    let { status, content } = await backend.retrieveFresh('firmwares_custom')
    if (status !== backendStatus.SUCCESS) {
        console.error('Error:', content)
        return
    }
    setFirmwaresCustom(content)
}

const UploadFwCustomPage = () => {

    const [firmwaresCustom, setFirmwaresCustom] = useState([])
    const [selecting, setSelecting] = useState(false)
    const [model, setModel] = useState('GF1200')
    const [version, setVersion] = useState('')
    const [file, setFile] = useState('')
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [user,] = useContext(UserContext)

    const header = useContext(MainHeaderContext)
    const backend = useContext(BackendContext)
    const uievents = useContext(UIEventsContext)
    const history = useHistory()



    useEffect(() => {

        if (user.superuser)
            history.push('/devices')


        header.title.set('Firmwares')
        fetchFirmwaresCustom(setFirmwaresCustom, setLoading, backend)


        uievents.setHandler('Firmwares-custom', () => {
            fetchFirmwaresCustom(setFirmwaresCustom, setLoading, backend)
        })

        // eslint-disable-next-line 
    }, [])

    const onUpdateListAction = () => {
        fetchFirmwaresCustom(setFirmwaresCustom, setLoading, backend)
    }

    const validateFwCustom = () => {

        let fwOfModel = firmwaresCustom.filter(fw => fw.model === model)
        if (fwOfModel.length >= 2) {
            return false
        }
        if (version === '' || version.length < 3) {
            return false
        }
        if (file === '' || file.size === 0 || file.size > MAX_FILE_SIZE) {
            return false
        }

        return true
    }


    const submit = async () => {

        setLoading(true)

        if (file.size === 0 || file.size === undefined || file.size > MAX_FILE_SIZE) {
            setLoading(false)
            setError(true)
            return
        }

        let result = await backend.create('firmwares_custom', {
            model: model,
            version: version
        })


        let id = result.content.id


        result = await backend.upload('fwfile_custom',
            file,
            { 'X-File-Id': id, 'X-Model': model }
        )

        if (result.status === backendStatus.SUCCESS) {
            setSelecting(false)
            setLoading(false)
            setSuccess(true)

            fetchFirmwaresCustom(setFirmwaresCustom, setLoading, backend)
            return
        }

        setLoading(false)
        setSelecting(false)
        setError(true)

    }

    const continueFn = () => {
        setLoading(false)
        setSuccess(false)
        setError(false)
    }

    return <div id='upload-fw-page' className='page container'>

        <DefaultStatusModals
            success={success}
            saving={loading}
            error={error}
            successText='Firmware enviado com sucesso'
            savingText='Aguarde enquanto seu firmware está sendo enviado'
            errorText='Houve um erro ao enviar o firmware  Customizado'
            continueFn={continueFn}
        ></DefaultStatusModals>
        <div className='subtitle'>Firmwares Customizados</div>

        <div className='fw-custom-container'>

            <Button className='itb-button'
                text='Enviar Firmware '
                onClick={() => setSelecting(true)}
            ></Button>

            <Overlay open={selecting} onClick={() => setSelecting(false)}></Overlay>
            {selecting &&

                <div id='fw-custom-container'>

                    <div className='close' onClick={() => { setSelecting(false) }}>
                        <CloseIcon size={15}></CloseIcon>
                    </div>

                    <div className='fw-custom-form'>
                        <Form className='upload-fw-form' onSubmit={submit} disableButton={!validateFwCustom()}>
                            <div className='subtitle'>Enviar firmware Customizado</div>
                            <Input id='fw-model'
                                label='Versão'
                                placeholder='1.0.0'
                                value={version}
                                onChange={(e) => setVersion(e.target.value.trim())}
                            >
                            </Input>

                            <RemotizeDevices
                                model={model}
                                setModel={setModel}
                                excludeModel={excludeModel}
                            ></RemotizeDevices>

                            <Input id='fw-model'
                                className='itb-input'
                                type='file'
                                label='Firmware'
                                onChange={async (e) => { setFile(e.target.files[0]) }}
                            >
                            </Input>
                        </Form>
                    </div>

                </div>
            }
        </div>
        <div>
            <UpdatefwCustomVersions
                firmwaresCustom={firmwaresCustom}
                onAction={onUpdateListAction}
            > </UpdatefwCustomVersions>

        </div>


    </div>
}

export default UploadFwCustomPage